import { FC, MutableRefObject, ReactNode } from "react"

interface Props {
    error: string
    label: string
    refLabel: MutableRefObject<HTMLDivElement | null>
    children: ReactNode
}

export const FormInput: FC<Props> = ({ error, label, refLabel, children }) => {
    return (
        <div className="form-booking-input-container">
            <div className="form-booking-input-container__bottom-gap" ref={refLabel}>
                {label}
            </div>
            <div>
                {children}
                {error ? (
                    <div className="form-booking-input-container__error-text">{error}</div>
                ) : null}
            </div>
        </div>
    )
}
